import { cva } from '@/styled-system/css';

export const datePickerBackdropRecipe = cva({
  variants: {
    modal: {
      true: {
        display: 'grid',
        placeItems: 'center',
        zIndex: 'datePicker',
        blockSize: 'auto',
        maxBlockSize: 'none',
        inlineSize: 'auto',
        maxInlineSize: 'none',
        paddingBlock: 'layout.looser',
        paddingInline: 'layout.tight',
        transitionProperty: {
          _motionReduce: 'none',
          _motionSafe: 'opacity',
        },
        transitionDuration: {
          _motionReduce: '0s',
          _motionSafe: '{durations.200}',
        },
        transitionTimingFunction: '{easings.ease-out}',

        _before: {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundColor: 'DatePicker.Backdrop.bg',
          zIndex: 1,
        },
      },
      false: {},
    },
    open: {
      true: {
        opacity: 1,
      },
      false: {
        opacity: 0,
      },
    },
  },
});
